import AboutCapitalAcres from "./components/AboutCapitalAcres";
import AboutDeveloper from "./components/AboutDeveloper";
import BestQuotes from "./components/BestQuotes";
import Details from "./components/Details";
import FloorPlan from "./components/FloorPlan";
import Footer from "./components/Footer";
import Form from "./components/Form";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Modal1 from "./components/Modal1";
import NewForm from "./components/NewForm";
import Pricing from "./components/Pricing";
import Slider from "./components/Slider";
import StripSection from "./components/StripSection";

function App() {
  const project = "Dosti West County";
  const galleryImages = [
    {
      src: "images/g1.jpg",
      alt: "gallery1",
      title: "gallery1",
    },
    {
      src: "images/g2.jpg",
      alt: "gallery2",
      title: "gallery2",
    },
    {
      src: "images/g3.jpg",
      alt: "gallery3",
      title: "gallery3",
    },
    {
      src: "images/g4.jpg",
      alt: "gallery4",
      title: "gallery4",
    },
  ];
  const amenityImages = [
    {
      src: "images/a1.jpg",
      alt: "amenity1",
      title: "amenity1",
    },
    {
      src: "images/a2.jpg",
      alt: "amenity2",
      title: "amenity2",
    },
    {
      src: "images/a3.jpg",
      alt: "amenity3",
      title: "amenity3",
    },
    {
      src: "images/a4.jpg",
      alt: "amenity4",
      title: "amenity4",
    },
  ];
  return (
    <>
      <div className="App">
        <Header />
        <Hero />
        <NewForm />
        <Details project={project} />
        <StripSection />
        <Pricing project={project} />
        <FloorPlan project={project} />
        <Slider project={project} title="Amenities" images={amenityImages} />
        <Slider project={project} title="Gallery" images={galleryImages} />
        <AboutDeveloper project={project} />
        <AboutCapitalAcres />
        <BestQuotes />
        <Footer />
        <Modal1 />
        <Form />
      </div>
    </>
  );
}

export default App;
